import {
  UNALERT_BUTTON,
  UNALERT_TITLE,
} from 'components/PDP/Arrangement/UnavailableBySchedule/translations/constants';

export const unavailableByScheduleCommonLocale = {
  [UNALERT_BUTTON]: 'View Available Products',
  [UNALERT_TITLE]: "We're sorry, this product is currently unavailable",
};
